import { useState, useEffect } from "react";
import "./ChristmasLights.css";

export default function ChristmasLights() {
  const [lights, setLights] = useState(0);

  useEffect(() => {
    const updateLights = () => {
      const lightWidth = 35;
      setLights(Math.floor(window.innerWidth / lightWidth));
    };
    updateLights();
    window.addEventListener("resize", updateLights);
    return () => window.removeEventListener("resize", updateLights);
  }, []);

  return <ul className="lights" style={{marginTop: '2%'}}>
    {Array.from({length: lights}, (_, i) => <li key={i}/>)}
  </ul>;
}
